export const CATEGORY_ROUTES: Record<string, string> = {
  Blog: 'blog',
  Vaga: 'careers',
  Publicação: 'publications',
  Defesa: 'defenses',
  Evento: 'events',
  Prêmio: 'awards'
}

export enum CategoriesNewsPortugueseEnum {
  Blog = 'Blog',
  Vacancy = 'Vaga',
  Publication = 'Publicação',
  Defense = 'Defesa',
  Event = 'Evento',
  Award = 'Prêmio'
}

export enum AudienceNewsEnum {
  External = 'Externo',
  Internal = 'Interno'
}
